import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const state = {
  emailAddress: null,
  siteRoot: window.pageData.siteRoot,
  submissionAttempted: false,
  submissionInProgress: false,
  viewModel: null
}

const mutations = {
  updateViewModel: (state, viewModel) => {
    state.viewModel = viewModel
  },
  setSubmissionAttempted: (state, value) => {
    state.submissionAttempted = value
  },
  setSubmissionInProgress: (state, value) => {
    state.submissionInProgress = value
  },
  setEmailAddress: (state, value) => {
    state.emailAddress = value
    // reset submission state when the email changes.
    state.submissionAttempted = false
  },
  setViewModel: (state, value) => {
    state.viewModel = value
  }
}

const getters = {
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  strict: debug
})



// WEBPACK FOOTER //
// ./WebResources/vue/shared/components/EmailSearch/store.js